var map = {
	"./figma.png": "6314",
	"./html.png": "926d",
	"./nicb.png": "a82b",
	"./python.png": "984b",
	"./react.png": "7145",
	"./sketch.png": "dc06",
	"./std.png": "5170",
	"./taib.png": "ab08",
	"./tba.png": "bc29",
	"./vue.png": "78a8",
	"./xamarin.png": "2a60"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4541";